import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Component to protect routes that require admin privileges
const AdminRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  // Check if user is logged in and has admin role
  if (!user) {
    // If no user is logged in, redirect to admin login page
    return <Navigate to="/admin/login" replace />;
  }

  const userRole = user?.data?.role || user?.role || user?.user?.role;
  const nonAdminRoles = ["user", "driver", "vendor", "corporate_admin", "corporate_staff", "staff"];

  if (!userRole || nonAdminRoles.includes(userRole.toLowerCase())) {
    // If user is logged in but not an admin/staff role, redirect to admin login
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminRoute;
